"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bankHolderNameReg = exports.postalReg = exports.paxBillingAddressReg = exports.bankInfoReg = exports.AlphabetReg = exports.capitalReg = exports.AlphanumericMixReg = exports.bankCardPureNumberReg = void 0;
exports.bankCardPureNumberReg = /^\w{4,34}$/;
exports.AlphanumericMixReg = /^[0-9a-zA-Z]+$/;
exports.capitalReg = /^[A-Z]+$/;
exports.AlphabetReg = /^[A-Za-z0-9]+$/;
exports.bankInfoReg = /^[\x20-\x7E]+$/;
exports.paxBillingAddressReg = /^[0-9A-Za-z /?:().,&'+-]+$/;
exports.postalReg = /^[A-Za-z0-9\s]*$/;
exports.bankHolderNameReg = /^[A-Za-z][A-Za-z\s()（）·\-']*$/;
//# sourceMappingURL=constants.js.map